import "phaser";
import $ from "jquery";
import { CST } from "../CST";
import { Math } from "phaser";

var question_index = 0;
var questions;
var current_question;
var questionNum = 1;
var sexiestPercentage = 0;
var yes = 0;
var yesCheck = false;
var noCheck = false;
var answerChecked;
var step1 = 0;
var step2 = 0;
var step3 = 0;
var step4 = 0;
var step5 = 0;

export default class Quiz extends Phaser.Scene {
  constructor() {
    super(CST.SCENES.QUIZ);
  }

  preload() {
    loadQuestionsFromDatabase();
  }

  create(data) {
    this.clickSound = this.sound.add("click-sound");

    this.styleBoldTop = {
      fontFamily: "Calibri",
      fontSize: 50,
      fontStyle: "bold",
      color: "#000000",
    };

    this.styleTop = {
      fontFamily: "Calibri",
      fontSize: 35,
      color: "#000000",
    };

    this.styleQuestionNum = {
      fontFamily: "Calibri",
      fontSize: 60,
      fontStyle: "bold",
      color: "#FFB400",
    };

    this.styleQuestion = {
      fontFamily: "Calibri",
      fontSize: 40,
      color: "#FFFFFF",
    };

    this.styleAnswer = {
      fontFamily: "Calibri",
      fontSize: 30,
      fontStyle: "bold",
      color: "#FFFFFF",
    };

    this.styleScoreText = {
      fontFamily: "Calibri",
      fontSize: 60,
      fontStyle: "bold",
      color: "#FFA500",
    };

    this.styleScoreNum = {
      fontFamily: "Calibri",
      fontSize: 60,
      fontStyle: "bold",
      color: "#FFFFFF",
    };

    this.styleConclusion = {
      fontFamily: "Calibri",
      fontSize: 40,
      fontStyle: "bold",
      color: "#FFFFFF",
    };

    this.count = 0;
    this.bg = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "generic-bg"
    );

    this.menu_btn = this.add
      .image(125, 835, "menu-button")
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        this.menu_btn.setTexture("menu-button");
      })
      .on("pointerup", () => {
        this.clickSound.play();
        this.menu_btn.setTexture("menu-button");
        location.reload();
      });

    this.nextBtn = this.add
      .image(1385, 835, "next-button-orange")
      .setDepth(1.5)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        this.nextBtn.setTexture("next-button-orange");
      })
      .on("pointerup", () => {
        this.nextBtn.setTexture("next-button-orange");
        this.clickSound.play();
        this.count++;
        this.nextStep(data);
      });
  }

  nextStep(data) {
    switch (this.count) {
      case 1:
        this.bg.setTexture("character-intro");
        this.popup = this.add.image(
          this.cameras.main.width / 2 - 250,
          this.cameras.main.height / 2 + 70,
          "intro-popup"
        );
        answerChecked = "NULL";
        break;
      case 2:
        this.menu_btn.destroy();
        this.bg.setTexture("questionnaire-bg");
        this.nextBtn.setVisible(false).disableInteractive();
        this.popup.setTexture("questionnaire-popup");
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        this.top_text_bold = this.add.text(270, 30, "STEP 1", this.styleBoldTop);
        this.top_text = this.add.text(
          430,
          40,
          "LEARNING ABOUT VERBAL SEXISM OR SEXUAL HARASSMENT",
          this.styleTop
        );
        this.question_number = this.add.text(
          this.cameras.main.width / 2 - 560,
          this.cameras.main.height / 2 - 280,
          "QUESTION " + questionNum,
          this.styleQuestionNum
        );
        this.question_text = this.add
          .text(
            this.cameras.main.width / 2 - 560,
            this.cameras.main.height / 2 - 180,
            current_question.question,
            this.styleQuestion
          )
          .setWordWrapWidth(1150, true);
        this.check_box_YES = this.add
          .sprite(
            this.cameras.main.width / 2 - 500,
            this.cameras.main.height / 2 + 50,
            "checkbox-sprite"
          )
          .setScale(0.7)
          .setFrame(0)
          .setInteractive({
            useHandCursor: true,
          })
          .on("pointerup", () => {
            if (
              (this.check_box_NO.setFrame(0) && this.check_box_YES.setFrame(0)) ||
              this.check_box_NO.setFrame(1)
            ) {
              this.check_box_YES.setFrame(1);
              this.check_box_NO.setFrame(0);
              yesCheck = true;
              noCheck = false;
              this.count++;
              setTimeout(() => {
                this.nextStep(data);
                this.pushQuestion(data, this);
                this.stepForward(this);
              }, 100);
            }
          });
        this.check_box_NO = this.add
          .sprite(
            this.cameras.main.width / 2 - 500,
            this.cameras.main.height / 2 + 150,
            "checkbox-sprite"
          )
          .setScale(0.7)
          .setFrame(0)
          .setInteractive({
            useHandCursor: true,
          })
          .on("pointerup", () => {
            if (
              (this.check_box_NO.setFrame(0) && this.check_box_YES.setFrame(0)) ||
              this.check_box_YES.setFrame(1)
            ) {
              this.check_box_YES.setFrame(0);
              this.check_box_NO.setFrame(1);
              yesCheck = false;
              noCheck = true;
              this.count++;
              setTimeout(() => {
                this.nextStep(data);
                this.pushQuestion(data, this);
                this.stepForward(this);
              }, 100);
            }
          });
        this.option_YES_text = this.add.text(
          this.cameras.main.width / 2 - 460,
          this.cameras.main.height / 2 + 40,
          current_question.option_1,
          this.styleAnswer
        );
        this.option_NO_text = this.add.text(
          this.cameras.main.width / 2 - 460,
          this.cameras.main.height / 2 + 140,
          current_question.option_2,
          this.styleAnswer
        );
        break;
      /*case 3:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 4:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 5:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 6:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 7:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 8:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;*/
      case 9:
        //this.pushQuestion(data, this);
        questionNum = 0;
        this.question_number.setVisible(false);
        this.question_text.setVisible(false);
        this.check_box_YES.setVisible(false).disableInteractive();
        this.check_box_NO.setVisible(false).disableInteractive();
        this.option_YES_text.setVisible(false);
        this.option_NO_text.setVisible(false);
        this.nextBtn.setVisible(true).setInteractive();
        this.bg.setTexture("character-outro");
        this.popup.setTexture("outro-step1-1");
        this.popup.x = this.cameras.main.width / 2 - 100;
        this.popup.y = this.cameras.main.height / 2 - 50;
        break;
      case 10:
        this.popup.setTexture("outro-step1-2");
        break;
      case 11:
        this.popup.setTexture("outro-step1-3");
        break;
      case 12:
        this.bg.setTexture("questionnaire-bg");
        this.popup.setTexture("questionnaire-popup").setScale(1.1);
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        sexiestPercentage = yes * 14.285;
        this.scoreText = this.add.text(
          this.cameras.main.width / 2 - 150,
          this.cameras.main.height / 2 - 260,
          "SCORE:",
          this.styleScoreText
        );
        this.scoreResult = this.add.text(
          this.cameras.main.width / 2 + 50,
          this.cameras.main.height / 2 - 260,
          Math.RoundAwayFromZero(sexiestPercentage) + "%",
          this.styleScoreNum
        );
        if (sexiestPercentage <= 28) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of verbal sexism or sexual harassment are low to moderate, but it is still important to challenge sexism and sexual harassment. Do not encourage or support any jokes or insults, and tell your manager, union or HR if the problem gets worse.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else if (sexiestPercentage >= 37 && sexiestPercentage <= 63) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of verbal sexism or sexual harassment you have witnessed are high and require urgent action. You should consider reporting it to your manager, union or HR department. Do not encourage or support the jokes or insults. If you can, explain that what they are saying is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of verbal sexism or sexual harassment you have witnessed are very high and require urgent action. You should consider reporting it to your manager, union or HR department. Do not encourage or support the jokes or insults. If you can, explain that what they are saying is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        }
        step1 = Math.RoundAwayFromZero(sexiestPercentage);
        questionNum = 1;
        break;
      case 13:
        this.nextBtn.setVisible(false).disableInteractive();
        current_question = nextQuestion();
        this.scoreText.destroy();
        this.scoreResult.destroy();
        this.conclusion.destroy();
        sexiestPercentage = 0;
        yes = 0;
        this.bg.setTexture("questionnaire-bg");
        this.popup.setTexture("questionnaire-popup");
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        this.top_text_bold.setText("STEP 2");
        this.top_text.setText("LEARNING ABOUT AVOIDANT SEXISM OR SEXUAL HARASSMENT");
        this.question_number.setVisible(true);
        this.question_text.setVisible(true);
        this.check_box_YES.setVisible(true).setInteractive();
        this.check_box_NO.setVisible(true).setInteractive();
        this.option_YES_text.setVisible(true);
        this.option_NO_text.setVisible(true);
        break;
      /*case 14:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 15:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 16:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 17:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 18:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 19:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;*/
      case 20:
        //this.pushQuestion(data, this);
        questionNum = 0;
        this.question_number.setVisible(false);
        this.question_text.setVisible(false);
        this.check_box_YES.setVisible(false).disableInteractive();
        this.check_box_NO.setVisible(false).disableInteractive();
        this.option_YES_text.setVisible(false);
        this.option_NO_text.setVisible(false);
        this.nextBtn.setVisible(true).setInteractive();
        this.bg.setTexture("character-outro");
        this.popup.setTexture("outro-step2-1");
        this.popup.x = this.cameras.main.width / 2 - 100;
        this.popup.y = this.cameras.main.height / 2 - 50;
        break;
      case 21:
        this.popup.setTexture("outro-step2-2");
        break;
      case 22:
        this.popup.setTexture("outro-step2-3");
        break;
      case 23:
        this.bg.setTexture("questionnaire-bg");
        this.popup.setTexture("questionnaire-popup").setScale(1.1);
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        sexiestPercentage = yes * 14.285;
        this.scoreText = this.add.text(
          this.cameras.main.width / 2 - 150,
          this.cameras.main.height / 2 - 260,
          "SCORE:",
          this.styleScoreText
        );
        this.scoreResult = this.add.text(
          this.cameras.main.width / 2 + 50,
          this.cameras.main.height / 2 - 260,
          Math.RoundAwayFromZero(sexiestPercentage) + "%",
          this.styleScoreNum
        );
        if (sexiestPercentage <= 28) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of avoidant sexism or sexual harassment are low to moderate, but it is still important to challenge sexism and sexual harassment. Tell your manager, union or HR if the problem gets worse.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else if (sexiestPercentage >= 37 && sexiestPercentage <= 63) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of avoidant sexism or sexual harassment you have witnessed are high and require urgent action. You should consider reporting it to your manager, union or HR department. Do not condone it. If you can, explain that what they are saying is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of avoidant sexism or sexual harassment you have witnessed are very high and require urgent action. You should consider reporting it to your manager, union or HR department. Do not condone it. If you can, explain that what they are saying is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        }
        step2 = Math.RoundAwayFromZero(sexiestPercentage);
        questionNum = 1;
        break;
      case 24:
        this.nextBtn.setVisible(false).disableInteractive();
        current_question = nextQuestion();
        this.scoreText.destroy();
        this.scoreResult.destroy();
        this.conclusion.destroy();
        sexiestPercentage = 0;
        yes = 0;
        this.bg.setTexture("questionnaire-bg");
        this.popup.setTexture("questionnaire-popup");
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        this.top_text_bold.setText("STEP 3");
        this.top_text.setText("LEARNING ABOUT DISCRIMINATORY SEXISM OR SEXUAL HARASSMENT");
        this.question_number.setVisible(true);
        this.question_text.setVisible(true);
        this.check_box_YES.setVisible(true).setInteractive();
        this.check_box_NO.setVisible(true).setInteractive();
        this.option_YES_text.setVisible(true);
        this.option_NO_text.setVisible(true);
        break;
      /*case 25:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 26:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 27:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 28:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 29:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;
            case 30:
                this.pushQuestion(data, this);
                this.stepForward(this);
                break;*/
      case 31:
        //this.pushQuestion(data, this);
        this.question_number.setVisible(false);
        this.question_text.setVisible(false);
        this.check_box_YES.setVisible(false).disableInteractive();
        this.check_box_NO.setVisible(false).disableInteractive();
        this.option_YES_text.setVisible(false);
        this.option_NO_text.setVisible(false);
        this.nextBtn.setVisible(true).setInteractive();
        this.bg.setTexture("character-outro");
        this.popup.setTexture("outro-step3-1");
        this.popup.x = this.cameras.main.width / 2 - 100;
        this.popup.y = this.cameras.main.height / 2 - 50;
        break;
      case 32:
        this.popup.setTexture("outro-step3-2");
        break;
      case 33:
        this.popup.setTexture("outro-step3-3");
        break;
      case 34:
        this.bg.setTexture("questionnaire-bg");
        this.popup.setTexture("questionnaire-popup").setScale(1.1);
        this.popup.x = this.cameras.main.width / 2;
        this.popup.y = this.cameras.main.height / 2 - 50;
        sexiestPercentage = yes * 14.285;
        this.scoreText = this.add.text(
          this.cameras.main.width / 2 - 150,
          this.cameras.main.height / 2 - 260,
          "SCORE:",
          this.styleScoreText
        );
        this.scoreResult = this.add.text(
          this.cameras.main.width / 2 + 50,
          this.cameras.main.height / 2 - 260,
          Math.RoundAwayFromZero(sexiestPercentage) + "%",
          this.styleScoreNum
        );
        if (sexiestPercentage <= 28) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of discriminatory sexism or sexual harassment may still be concerning, it is still important to challenge sexism and sexual harassment. Do not condone it, and tell your manager, union or HR if the problem gets worse.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else if (sexiestPercentage >= 37 && sexiestPercentage <= 63) {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of discriminatory sexism or sexual harassment you have witnessed are high and require urgent action. You should consider reporting it to your manager, union or HR department. Do not condone it. If you can, explain that what they are saying is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        } else {
          this.conclusion = this.add
            .text(
              this.cameras.main.width / 2 - 600,
              this.cameras.main.height / 2 - 120,
              "The levels of discriminatory sexism or sexual harassment you have witnessed are very high and require urgent action, such as reporting it to your manager, union or HR. Do not condone it. If you can, tell the people involved why what they are doing is sexist or a form of sexual harassment.",
              this.styleConclusion
            )
            .setWordWrapWidth(1150, true);
        }
        step3 = Math.RoundAwayFromZero(sexiestPercentage);
        break;
      case 35:
        questionNum = 1;
        question_index = 0;
        sexiestPercentage = 0;
        yes = 0;
        this.pushResults(data);
        this.scene.start(CST.SCENES.ENDSCREENQUIZ, {
          step1: step1,
          step2: step2,
          step3: step3,
        });
        break;
    }
  }

  pushQuestion(id, self) {
    if (yesCheck === true) {
      answerChecked = "Yes";
      yes++;
    } else if (noCheck === true) {
      answerChecked = "No";
    }

    var userAnswer = {
      User_ID: id.User_ID,
      step: self.top_text_bold.text,
      question_id: current_question.ID,
      answer: answerChecked,
    };

    $.ajax({
      type: "POST",
      url: "/Antisexism/website/post-quiz-to-ddbb.php",
      dataType: "JSON",
      data: userAnswer,
    }).responseJSON;

    yesCheck = false;
    noCheck = false;
    answerChecked = "NULL";
  }

  stepForward(self) {
    current_question = nextQuestion();
    questionNum++;
    self.check_box_YES.setFrame(0);
    self.check_box_NO.setFrame(0);
    self.question_number.text = "QUESTION " + questionNum;
    self.question_text.text = current_question.question;
  }

  pushResults(id) {
    var userAnswer = {
      User_ID: id.User_ID,
      step1: step1,
      step2: step2,
      step3: step3,
    };

    $.ajax({
      type: "POST",
      url: "/Antisexism/website/post-quiz-results-to-ddbb.php",
      dataType: "JSON",
      data: userAnswer,
    }).responseJSON;
  }
}

function loadQuestionsFromDatabase() {
  $.ajax({
    async: true,
    type: "get",
    url: "website/get-questions-to-json.php",
    dataType: "JSON",
    success(data) {
      questions = data;
      current_question = nextQuestion();
    },
    error(data) {
      console.log(data);
    },
  }).responseJSON;
}

function nextQuestion() {
  if (question_index != questions.length) {
    current_question = questions[question_index];
    question_index++;
    return current_question;
  }
}
